import { supabase } from '@/core/supabaseClient';
import type { WorkoutHistoryItem } from '../types';

/** Removes one workout from a local list copy (used for optimistic UI updates and tests). */
export function removeWorkoutFromList(items: WorkoutHistoryItem[], id: string): WorkoutHistoryItem[] {
  return items.filter((w) => w.id !== id);
}

/** Deletes a workout row by primary key (scoped to the owning user for RLS / safety). */
export async function deleteWorkout(id: string, userId: string): Promise<{ error: Error | null }> {
  const { data, error } = await supabase
    .from('workouts')
    .delete()
    .eq('id', id)
    .eq('user_id', userId)
    .select('id');

  if (error) {
    console.error('[deleteWorkout] Supabase error:', error.message, error);
    return { error: new Error(error.message) };
  }

  if (!data?.length) {
    console.error('[deleteWorkout] No rows deleted — check auth session or DELETE RLS policy.', {
      id,
      userId,
    });
    return {
      error: new Error('Rekord nie został usunięty (brak dopasowania lub brak uprawnień).'),
    };
  }

  return { error: null };
}
